import React, { useRef, useState } from 'react';
import { FiEdit2, FiCheckCircle, FiFileText, FiTrash2 } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { puede } from '../../utils/permisos';
import api from '../../utils/api';

export function accionesPedido(usuario, pedido) {
  const bloqueado = pedido.estado === 'facturado' || Boolean(pedido.facturaId);
  const editar = puede(usuario, 'presupuestos', 'editar') && !bloqueado;
  return {
    editar: editar && !pedido.stockDescontado,
    confirmar: editar && pedido.estado === 'pendiente' && !pedido.stockDescontado,
    facturar: editar,
    eliminar: puede(usuario, 'presupuestos', 'eliminar') && !bloqueado,
  };
}

export default function PedidoAcciones({ pedido, onEditar, onActualizado, onEliminado, compacto = false }) {
  const { usuario } = useAuth();
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState(null);
  const ocupadoRef = useRef(false);
  const ejecutar = async (accion) => {
    if (ocupadoRef.current || !accionesPedido(usuario, pedido)[accion]) return;
    if (accion === 'editar') { onEditar(pedido); return; }
    const mensajes = {
      confirmar: '¿Deseas confirmar este pedido y descontar el stock disponible?',
      facturar: '¿Deseas generar la factura de este pedido y continuar?',
      eliminar: `¿Eliminar este pedido? ${pedido.stockDescontado ? 'Se repondrá el stock descontado.' : 'No se modificará el stock porque no se ha descontado.'} Si tiene una factura asociada, no se podrá eliminar.`,
    };
    ocupadoRef.current = true;
    setOcupado(true);
    setError(null);
    try {
      let revision;
      let mensaje = mensajes[accion];
      if (accion === 'eliminar') {
        const { data } = await api.get(`/pedidos/${pedido._id}/eliminacion`);
        if (!data?.advertencia || !data?.revision) throw new Error('Vista previa no disponible');
        mensaje = data.advertencia;
        revision = data.revision;
      }
      if (!accionesPedido(usuario, pedido)[accion] || !window.confirm(mensaje) || !accionesPedido(usuario, pedido)[accion]) return;
      if (accion === 'eliminar') await api.delete(`/pedidos/${pedido._id}`, { data: { revision } });
      else await api.post(`/pedidos/${pedido._id}/${accion}`);
      await onActualizado(accion);
      if (accion === 'eliminar') onEliminado?.();
    } catch (err) {
      const datos = err.response?.data;
      setError(datos?.detalle ? `${datos.error}: ${JSON.stringify(datos.detalle)}` : (datos?.error || 'No se pudo completar la acción'));
    } finally {
      ocupadoRef.current = false;
      setOcupado(false);
    }
  };
  const disponibles = accionesPedido(usuario, pedido);
  const botones = [
    { accion: 'editar', titulo: 'Editar', texto: 'Editar pedido', Icono: FiEdit2 },
    { accion: 'confirmar', titulo: 'Confirmar (descuenta stock)', texto: 'Confirmar pedido', Icono: FiCheckCircle },
    { accion: 'facturar', titulo: 'Generar factura', texto: 'Generar factura', Icono: FiFileText },
    { accion: 'eliminar', titulo: 'Eliminar', texto: 'Eliminar', Icono: FiTrash2 },
  ];
  return (
    <>
      {botones.filter(({ accion }) => disponibles[accion]).map(({ accion, titulo, texto, Icono }) => (
        <button key={accion} type="button" className={`${compacto ? 'icon-btn' : 'btn'}${accion === 'eliminar' ? ' danger' : ''}`} title={titulo} aria-label={titulo} disabled={ocupado}
          onClick={(event) => { event.stopPropagation(); ejecutar(accion); }} onDoubleClick={(event) => event.stopPropagation()}>
          <Icono />{!compacto && ` ${texto}`}
        </button>
      ))}
      {error && <span className="alert-error" role="alert">{error}</span>}
    </>
  );
}